<template>
    <div class="topbar">
        <div class="logo-container">
            <span>Tucuxi</span>
            <img src="@/assets/images/logo/logo-color.svg" alt="" />
        </div>

        <div class="tools">
            <div class="group">
                <!--
                <button type="button" class="btn link" disabled>
                    <img src="@/assets/pictos/topbar-tools/save.svg" />
                </button>
                -->

                <button type="button" class="btn link" @click="startNewPatient">
                    <img src="@/assets/pictos/topbar-tools/new-patient.svg" />
                </button>

                <!--
                <button type="button" class="btn link" disabled>
                    <img src="@/assets/pictos/topbar-tools/pending-requests.svg" />
                </button>
                -->
            </div>

            <div class="group">
                <lang-switch />
                
                <button type="button" class="btn link" @click="backToHome">
                    <img src="@/assets/pictos/topbar-tools/shutdown.svg" />
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { usePatientStore } from '@/store/patient';
import { useRequestDataStore } from '@/store/request-data';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import LangSwitch from './LangSwitch.vue';

export default defineComponent({
    components: { LangSwitch },

    setup()
    {
        const i18n = useI18n();
        const router = useRouter();

        function startNewPatient()
        {
            if (!confirm(i18n.t('general.areYouSureToLeave'))) {
                return;
            }

            // Clear stores so we start with a fresh patient
            usePatientStore().$reset();
            useRequestDataStore().deselectDrug();

            // Back to the 1st page
            router.push("/app");
        }

        function backToHome()
        {
            if (confirm(i18n.t('general.areYouSureToLeave'))) {
                router.push("/");
            }
        }

        return {
            startNewPatient,
            backToHome,
        };
    }
})
</script>

<style lang="scss" scoped>

.topbar {
    display: flex;
    align-items: stretch;
    background-color: $gray-300;
    color: $white;

    & > .logo-container {
        padding: 0.25rem;
        font-size: 2rem;

        & > * {
            vertical-align: middle;
        }

        & > img {
            margin-left: 1rem;
        }
    }

    & > .tools {
        display: flex;
        margin-left: auto;

        & > .group {
            display: flex;
        }

        & > .group:not(:first-child) {
            margin-left: 3rem;
        }
    }

    // Tool buttons styles
    & > .tools > .group > * {
        padding: 0.75rem;
        color: $gray-600;

        &:disabled,
        &.disabled {
            opacity: 0.5;
        }

        &:hover {
            background-color: $blue-light;
            color: darken($gray-600, 60%);

            & > img {
                filter: brightness(40%);
            }
        }
    }
}

</style>
